import {CircularProgress, createStyles, Grid, makeStyles, Theme} from "@material-ui/core"
import React, {useEffect, useState} from "react"
import AuthCode from 'react-auth-code-input';
import StateMessage from "./components/StateMessage/StateMessage";
import Span from "./components/Span/Span";
import Button from "./components/Button/Button";
import Link from "./components/Link/Link";
import {BFF_ONBOARDING_URL} from "../../index";

const useStyles = makeStyles(
   ({spacing}: Theme) =>
      createStyles({
         root: {
            paddingRight: spacing(10),
            paddingLeft: spacing(10),
            paddingBottom: spacing(5),
            paddingTop: spacing(5),
            width: "100%"
         },
         authInput: {
            paddingTop: spacing(2),
            textAlign: 'center'
         },
         span: {
            textAlign: 'left',
            marginLeft: '12%',
            marginTop: '-5%'
         },
        spanErrorMessage: {
          textAlign: 'left',
          marginLeft: '12%',
          marginTop: '1%',
          color: 'red'
        },
         container: {
            padding: '16px'
         },
         inputs: {
            width: '45px',
            height: '45px',
            padding: 0,
            fontSize: '24px',
            textAlign: 'center',
            color: "rgb(55, 62, 69)",
            fontFamily: "Rubik",
            border: '1px solid #bdbbbb',
            borderRadius: '4px',
            background: '#fff',
            backgroundClip: 'padding-box',
            "&:focus": {
               appearance: "none",
               outline: 0,
               boxShadow: "0 0 0 3px rgb(131 192 253 / 50%)"
            }
         },
         link: {
            paddingTop: spacing(2),
            justifyContent: 'center',
            display: 'flex'
         },
         circularProgress: {
            justifyContent: 'center',
            display: 'flex'
         },
         buttonContainer: {
            width: "85%",
            marginLeft: "8%",
            marginTop: "8%"
         }
      }),
   {name: "user-update-validation-page"}
)

const OtpValidationBody = ({email, setShowModal, setModalWasConfirmed, setLoadingAccountForm}: any) => {
   const classes = useStyles()
   const [token, setToken] = useState("")
   const [isLoading, setIsLoading] = useState(false)
   const [error, setError] = useState<any>(null)

   const handleOnChange = (res: string) => {
      setToken(res)
   };

   useEffect(() => {
     fetch(`${BFF_ONBOARDING_URL}/codes`, {
       method: 'post',
       headers: {'Content-Type':'application/json'},
       body: JSON.stringify({
         "email": email,
       })
     })
   }, [email]);


   const handleAuthorization = () => {
     setIsLoading(true)
     fetch(`${BFF_ONBOARDING_URL}/codes/` + email, {
       method: 'get',
       headers: {
         'Content-Type': 'application/json',
         'Code-Number': token,
       }
     })
        .then(res => {
          switch (res.status) {
            case 200:
              setIsLoading(false)
              setShowModal(false)
              setModalWasConfirmed(true)
              setError(null)
              break;
            case 409:
              setError("El código no coincide con el que te enviamos por mail!")
              setIsLoading(false)
              break;
            case 500:
              setError("Ocurrió un error inesperado. Intente nuevamente")
              setIsLoading(false)
              break;
            case 503:
              setError("Ocurrió un error inesperado. Intente nuevamente")
              setIsLoading(false)
              break;
            default:
              setError("Ocurrió un error inesperado. Intente nuevamente")
              setIsLoading(false)
              break;
          }
        })
   };


   return (
      <div>
         <div className={classes.root}>
           <Grid item xs={12}>
             <div>
               <StateMessage
                  title='Ingresa el codigo de verificación'
                  subtitle={'Para validar el email, enviamos un código a:\n' + email}
                  illustration='lineal_mail_creado'
               >
                 <div/>
               </StateMessage>
             </div>
             <div className={classes.authInput}>
               <AuthCode
                  allowedCharacters='numeric'
                  onChange={handleOnChange}
                  containerClassName={classes.container}
                  inputClassName={classes.inputs}/>
             </div>
             <div className={classes.span}>
               <Span type='5' align='left' variant='disabled' weight='regular'>
                 Recorda revisar el correo no deseado.
               </Span>
             </div>
             {error && (
                <div className={classes.spanErrorMessage}>
                  <Span type='3' align='left' variant='disabled' weight='regular'>
                    {error}
                  </Span>
                </div>
                )
             }
             <div className={classes.buttonContainer}>
               {!isLoading ? (
                  <div>
                    <Button
                       id="authConfirm"
                       variant="primary"
                       size="md-full"
                       disabled={token.length !== 6}
                       onClick={() => {
                         setError(null)
                         handleAuthorization()
                        }
                       }
                    >
                      <Span type='1' weight='regular'>
                        Verificar
                      </Span>
                    </Button>
                  </div>
               ) : (
                  <div className={classes.circularProgress}>
                    <CircularProgress size={40}/>
                  </div>
               )}
               <div className={classes.link}>
                 <Link
                    variant='primary'
                    onClick={() => {
                      setShowModal(false)
                      setLoadingAccountForm(false)
                      setError(null)
                    }}
                    target='_blank' size='md'>
                   Volver
                 </Link>
               </div>
             </div>
           </Grid>
         </div>
      </div>
   )
}

export default OtpValidationBody
